export const formatHumanReadableDate = (dateString: string): string => {
	const date = new Date(dateString);
	const now = new Date();

	// Get the day difference
	const dayDiff = Math.floor((date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

	// Format time
	const timeOptions: Intl.DateTimeFormatOptions = {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
	};
	const timeStr = date.toLocaleTimeString([], timeOptions).replace(/am|pm/gi, (match) => match.toUpperCase());

	// Format day with ordinal suffix
	const getOrdinalSuffix = (day: number): string => {
		if (day > 3 && day < 21) return 'th';
		switch (day % 10) {
			case 1:
				return 'st';
			case 2:
				return 'nd';
			case 3:
				return 'rd';
			default:
				return 'th';
		}
	};

	const dayWithSuffix = `${date.getDate()}${getOrdinalSuffix(date.getDate())}`;
	const monthName = date.toLocaleDateString([], { month: 'long' });
	const year = date.getFullYear();
	const dayName = date.toLocaleDateString([], { weekday: 'long' });

	// Capitalize first letter of day name
	const capitalizedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1).toLowerCase();

	// Relative date logic
	if (dayDiff === 0) {
		return `Today at ${timeStr}`;
	} else if (dayDiff === 1) {
		return `Tomorrow at ${timeStr}`;
	} else if (dayDiff > 1 && dayDiff <= 7) {
		// Within next week
		return `${capitalizedDayName} at ${timeStr}`;
	} else if (dayDiff > 7 && dayDiff <= 14) {
		return `Next week ${capitalizedDayName} at ${timeStr}`;
	} else if (dayDiff < 0) {
		// Past dates
		const absDayDiff = Math.abs(dayDiff);
		if (absDayDiff === 1) {
			return `Yesterday at ${timeStr}`;
		} else if (absDayDiff <= 7) {
			return `Last ${capitalizedDayName} at ${timeStr}`;
		} else {
			return `${dayWithSuffix} ${monthName} ${year} at ${timeStr}`;
		}
	} else {
		// Far future dates
		return `${dayWithSuffix} ${monthName} ${year} at ${timeStr}`;
	}
};
